if (!customElements.get('ap-walter-options')) {
  customElements.define('ap-walter-options', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.section = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.variants = JSON.parse(this.querySelector('[data-ap-main-variants]').textContent);
      this.isFlat = this.dataset.model.startsWith('F');
      this.format = new Intl.NumberFormat(this.dataset.locale || 'de-AT', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.onChange = this.handleChange.bind(this);
      this.form.addEventListener('change', this.onChange);
      this.setupInfo();
      if (this.isFlat) {
        const selected = this.currentVariant();
        this.querySelector('[data-ap-moso]').checked = selected?.options[1] === 'mit Verkleidung';
        const iso = this.querySelector('[data-key="insulation"]');
        const plus = this.querySelector('[data-key="flatplus"]');
        if (iso && !iso.disabled) iso.checked = selected?.options[0] === 'mit Isolierung';
        if (plus && !plus.disabled) plus.checked = selected?.options[2] === 'mit Flat+';
        this.section.setAttribute('data-ap-walter-flat-ready', '');
      }
      this.update();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.infoEvents?.abort();
      this.ready = false;
    }

    setupInfo() {
      this.infoEvents = new AbortController();
      const events = { signal: this.infoEvents.signal };
      const infos = Array.from(this.querySelectorAll('[data-ap-info]'));
      const close = (info) => {
        info.dataset.pinned = 'false';
        info.querySelector('[data-ap-info-trigger]').setAttribute('aria-expanded', 'false');
        info.querySelector('[role="region"]').hidden = true;
      };
      const open = (info) => {
        info.querySelector('[data-ap-info-trigger]').setAttribute('aria-expanded', 'true');
        info.querySelector('[role="region"]').hidden = false;
      };
      infos.forEach(info => {
        const button = info.querySelector('[data-ap-info-trigger]');
        const card = info.closest('.ap-walter-card');
        button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') open(info);
        }, events);
        button.addEventListener('click', () => {
          if (info.dataset.pinned === 'true') close(info);
          else { open(info); info.dataset.pinned = 'true'; }
        }, events);
        card.addEventListener('pointerleave', () => {
          if (info.dataset.pinned !== 'true') close(info);
        }, events);
        info.querySelector('[data-ap-info-close]').addEventListener('click', () => {
          close(info);
          button.focus();
        }, events);
        info.addEventListener('focusout', event => {
          if (!info.contains(event.relatedTarget) && !event.relatedTarget?.matches('[data-ap-info-trigger]')) close(info);
        }, events);
      });
      document.addEventListener('click', event => {
        infos.filter(info => !info.contains(event.target)).forEach(close);
      }, events);
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        infos.forEach(info => {
          if (info.contains(document.activeElement) && document.activeElement !== info.querySelector('[data-ap-info-trigger]')) info.querySelector('[data-ap-info-trigger]').focus();
          close(info);
        });
      }, events);
    }

    currentVariant() {
      return this.variants.find(variant => String(variant.id) === this.form.elements.id.value);
    }

    handleChange(event) {
      if (this.updating || event.target.name === 'ap-ignore') return;
      this.update();
    }

    money(cents) {
      return this.format.format(cents / 100);
    }

    baseVariant(withMoso) {
      return this.variants.find(variant => variant.options[0] === 'ohne Isolierung' && variant.options[1] === (withMoso ? 'mit Verkleidung' : 'ohne Verkleidung') && (!variant.options[2] || variant.options[2] === 'ohne Flat+'));
    }

    update() {
      this.updating = true;
      const poolType = this.querySelector('[data-ap-pooltype]');
      const specialPool = poolType && poolType.value !== '' && poolType.value !== 'Skimmerbecken';
      const overflowNote = this.querySelector('[data-ap-overflow]');
      if (overflowNote) overflowNote.hidden = !specialPool;
      const formError = this.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (!specialPool && overflowNote && formError?.querySelector('.product-form__error-message')?.textContent.trim() === overflowNote.textContent.trim()) {
        formError.hidden = true;
      }
      if (poolType) poolType.setCustomValidity(specialPool ? overflowNote.textContent.trim() : '');
      if (this.isFlat) {
        const variant = this.baseVariant(this.querySelector('[data-ap-moso]').checked);
        if (variant) {
          this.form.elements.id.value = variant.id;
          const sku = this.section.querySelector('[id^="Sku-"]');
          if (sku) sku.textContent = `${this.dataset.skuLabel} ${variant.sku}`;
          this.section.querySelectorAll('[id^="price-"] .price-item--regular, .ap-main-product__price-note-value').forEach(el => { el.textContent = this.money(variant.price); });
          const button = this.form.querySelector('[name="add"]');
          button.disabled = !variant.available;
          const plain = this.baseVariant(false);
          const moso = this.baseVariant(true);
          this.querySelector('[data-ap-moso-price]').textContent = moso && plain ? `+ ${this.money(moso.price - plain.price)}` : '';
        }
      }
      const quick = this.querySelector('[data-key="quick"]');
      if (quick) {
        this.querySelector('[data-ap-quick-config]').hidden = !quick.checked;
        const selected = this.querySelector('[data-ap-quick-select]').selectedOptions[0];
        quick.dataset.variant = selected.value;
        quick.dataset.sku = selected.dataset.sku;
        quick.dataset.price = selected.dataset.price;
        this.querySelector('[data-ap-quick-price]').textContent = `+ ${this.money(Number(selected.dataset.price))}`;
      }
      const variant = this.currentVariant();
      const quantity = Math.max(1, Number(this.form.elements.quantity?.value || 1));
      const extra = this.selectedAddons().reduce((sum, input) => sum + Number(input.dataset.price) * Number(input.dataset.ratio), 0);
      const total = this.money(((variant?.price || 0) + extra) * quantity);
      this.querySelector('[data-ap-total]').textContent = total;
      document.querySelector('[data-ap-sticky-price]')?.replaceChildren(document.createTextNode(total));
      this.updating = false;
    }

    selectedAddons() {
      return Array.from(this.querySelectorAll('[data-ap-addon]:checked:not(:disabled)'));
    }

    buildCartPayload(formData) {
      this.update();
      const poolType = this.querySelector('[data-ap-pooltype]');
      if (poolType && !poolType.checkValidity()) {
        poolType.reportValidity();
        throw new Error(this.querySelector('[data-ap-overflow]').textContent.trim());
      }
      const variant = this.currentVariant();
      if (!variant?.available) throw new Error(this.dataset.error);
      const quantity = Number(formData.get('quantity') || 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(this.dataset.error);
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      const addons = this.selectedAddons();
      const configuration = crypto.randomUUID();
      if (addons.length) { properties._ap_walter_configuration = configuration; properties._ap_walter_ratio = '1'; }
      const items = [{ id: variant.id, quantity, properties }];
      if (formData.get('selling_plan')) items[0].selling_plan = formData.get('selling_plan');
      for (const input of addons) {
        items.push({ id: Number(input.dataset.variant), quantity: quantity * Number(input.dataset.ratio), parent_id: variant.id, properties: { [this.dataset.forLabel]: `${this.dataset.productTitle} · ${variant.sku}`, _ap_walter_configuration: configuration, _ap_walter_parent_sku: variant.sku, _ap_walter_ratio: input.dataset.ratio } });
      }
      return { items };
    }
  });
}
